import React from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import Product from '../components/product'
// import Slider from 'react-owl-carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';



export default function home() {
  const productImages = [
    "../footwear/9-assg1102n-9-abros-white-mint-original.jpeg",
    "../footwear/9-assg1102n-9-abros-white-mint-original1.jpeg",
    "../footwear/9-assg1102n-9-abros-white-mint-original2.jpeg",
    "../footwear/9-assg1102n-9-abros-white-mint-original3.jpeg",
  ];
  return (
    <div>
      <Header />
      {/* slider section */}
      <section className="slider my-5">
        <div className="container">
          <div className="row">
            <div className="col-md-10 m-auto">
              <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel carousel-fade">
                <div className="carousel-indicators">
                  <button type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                  <button type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide-to="1" aria-label="Slide 2"></button>
                  <button type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide-to="2" aria-label="Slide 3"></button>
                  <button type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide-to="3" aria-label="Slide 4"></button>
                  <button type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide-to="4" aria-label="Slide 5"></button>
                </div>
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img src="../saree.jpg" className="d-block w-100" alt="..." />
                  </div>
                  <div className="carousel-item">
                    <img src="../women.webp" className="d-block w-100" alt="..." />
                  </div>
                  <div className="carousel-item">
                    <img src="../child-sale.jpg" className="d-block w-100" alt="..." />
                  </div>
                  <div className="carousel-item">
                    <img src="../electronic_accessories.jpg" className="d-block w-100" alt="..." />
                  </div>
                  <div className="carousel-item">
                    <img src="../hot_sale.jpg" className="d-block w-100" alt="..." />
                  </div>
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 24 24"><path fill="#fff" d="M19.5 13H7.914l4.5 4.5L11 18.914L4.086 12L11 5.086L12.414 6.5l-4.5 4.5H19.5z" /></svg>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 24 24"><path fill="#fff" d="M19.5 13H7.914l4.5 4.5L11 18.914L4.086 12L11 5.086L12.414 6.5l-4.5 4.5H19.5z" /></svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* slider section */}

      {/* Home Series */}
      <section className="sale_items py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="d-flex justify-content-between">
                <h2 className='fs-4 fw_600'>Home Series</h2>
                <div className="right d-flex align-items-center">
                  <a href="#" title='View All' className='fs_13'>View all <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48"><path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M19 12L31 24L19 36" /></svg></a>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <Product images={[
                "../home/kitchen/cooker.jpeg",
                "../home/kitchen/cooker1.jpeg",
                "../home/kitchen/cooker2.jpeg",
                "../home/kitchen/cooker3.jpeg",
                "../home/kitchen/cooker4.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../home/kitchen/coffe-mug.jpeg",
                "../home/kitchen/coffe-mug1.jpeg",
                "../home/kitchen/coffe-mug2.jpeg",
                "../home/kitchen/coffe-mug3.jpeg",
                "../home/kitchen/coffe-mug4.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../home/kitchen/lunch-box.jpeg",
                "../home/kitchen/lunch-box1.jpeg",
                "../home/kitchen/lunch-box2.jpeg",
                "../home/kitchen/lunch-box3.jpeg",
                "../home/kitchen/lunch-box4.jpeg",
                "../home/kitchen/lunch-box5.jpeg",
                "../home/kitchen/lunch-box6.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../electronics/bluetooth/noise.jpeg",
                "../electronics/bluetooth/noise1.jpeg",
                "../electronics/bluetooth/noise2.jpeg",
                "../electronics/bluetooth/noise3.jpeg",
                "../electronics/bluetooth/noise4.jpeg",
                "../electronics/bluetooth/noise5.jpeg"
              ]} />
            </div>
          </div>
        </div>
      </section>
      {/* Home Series */}

      {/* Popular Sale */}
      <section className="sale_items py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="d-flex justify-content-between">
                <h2 className='fs-4 fw_600'>Sport Shoes Sale</h2>
                <div className="right d-flex align-items-center">
                  <a href="#" title='View All' className='fs_13'>View all <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48"><path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M19 12L31 24L19 36" /></svg></a>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <Product images={[
                "../footwear/black.jpeg",
                "../footwear/black1.jpeg",
                "../footwear/black2.jpeg",
                "../footwear/black3.jpeg",
                "../footwear/black4.jpeg",
                "../footwear/black5.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={productImages} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../footwear/grey.jpeg",
                "../footwear/grey1.jpeg",
                "../footwear/grey2.jpeg",
                "../footwear/grey3.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../footwear/green.jpeg",
                "../footwear/green1.jpeg",
                "../footwear/green2.jpeg",
                "../footwear/green3.jpeg"
              ]} />
            </div>
          </div>
        </div>
      </section>
      {/* Popular Sale */}

      {/* Branded Sale Offer */}
      <section className="offer_sale py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-8 m-auto text-center mb-4">
              <span className='text-muted fs_12 text-decoration-underline'>Offer</span>
              <h2 className='font_cursive'>Don't Miss Sale Offer </h2>
            </div>
            <div className="col-md-6">
              <a href="#" title='' className='box'>
                <img className='sale_img' src="../saree.jpg" alt="" title='' />
                <div className="det">
                  <a href="#" title='View Now' className='btn_outline_primary'>View Now</a>
                </div>
              </a>
            </div>
            <div className="col-md-6">
              <a href="#" title='' className='box'>
                <img className='sale_img' src="../hot_sale.jpg" alt="" title='' />
                <div className="det">
                  <a href="#" title='View Now' className='btn_outline_secondary'>View Now</a>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Branded Sale Offer */}

      {/* Womens Top Products */}
      <section className="sale_items py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="d-flex justify-content-between">
                <h2 className='fs-4 fw_600'>Women's Top Products</h2>
                <div className="right d-flex align-items-center">
                  {/* <a href='#' title='Grid View' className="grid me-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"><path fill="currentColor" d="M14 10v4h-4v-4zm2 0h5v4h-5zm-2 11h-4v-5h4zm2 0v-5h5v4a1 1 0 0 1-1 1zM14 3v5h-4V3zm2 0h4a1 1 0 0 1 1 1v4h-5zm-8 7v4H3v-4zm0 11H4a1 1 0 0 1-1-1v-4h5zM8 3v5H3V4a1 1 0 0 1 1-1z" /></svg>
                  </a>
                  <a href='#' title='List View' className="list me-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"><path fill="currentColor" d="M3 13h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7zm-4 6h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7z" /></svg>
                  </a> */}

                  <a href="#" title='View All' className='fs_13'>View all <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48"><path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M19 12L31 24L19 36" /></svg></a>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              {/* <Product images={productImages} /> */}
              <Product images={[
                "../womens/gown.jpeg",
                "../womens/gown1.jpeg",
                "../womens/gown2.jpeg",
                "../womens/gown3.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../womens/brown.jpeg",
                "../womens/brown1.jpeg",
                "../womens/brown2.jpeg",
                "../womens/brown3.jpeg",
                "../womens/brown4.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../womens/heel.jpeg",
                "../womens/heel1.jpeg",
                "../womens/heel2.jpeg",
                "../womens/heel3.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../womens/pink.jpeg",
                "../womens/pink1.jpeg",
                "../womens/pink2.jpeg",
                "../womens/pink3.jpeg"
              ]} />
            </div>
          </div>
        </div>
      </section>
      {/* Womens Top Products */}


      {/* Boys & Kids Top Products */}
      <section className="sale_items py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="d-flex justify-content-between">
                <h2 className='fs-4 fw_600'>Boys & Kids Top Products</h2>
                <div className="right d-flex align-items-center">
                  {/* <a href='#' title='Grid View' className="grid me-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"><path fill="currentColor" d="M14 10v4h-4v-4zm2 0h5v4h-5zm-2 11h-4v-5h4zm2 0v-5h5v4a1 1 0 0 1-1 1zM14 3v5h-4V3zm2 0h4a1 1 0 0 1 1 1v4h-5zm-8 7v4H3v-4zm0 11H4a1 1 0 0 1-1-1v-4h5zM8 3v5H3V4a1 1 0 0 1 1-1z" /></svg>
                  </a>
                  <a href='#' title='List View' className="list me-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"><path fill="currentColor" d="M3 13h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7zm-4 6h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7z" /></svg>
                  </a> */}

                  <a href="#" title='View All' className='fs_13'>View all <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48"><path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M19 12L31 24L19 36" /></svg></a>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <Product images={[
                "../baby/top.jpeg",
                "../baby/top1.jpeg",
                "../baby/top2.jpeg",
                "../baby/top3.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../boy/shorts.jpeg",
                "../boy/shorts1.jpeg",
                "../boy/shorts2.jpeg",
                "../boy/shorts3.jpeg",
                "../boy/shorts4.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../baby/footwear.jpeg",
                "../baby/footwear1.jpeg",
                "../baby/footwear2.jpeg",
                "../baby/footwear3.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../baby/jacket.jpeg",
                "../baby/jacket1.jpeg",
                "../baby/jacket2.jpeg",
                "../baby/jacket3.jpeg"
              ]} />
            </div>
          </div>
        </div>
      </section>
      {/* Boys & Kids Top Products */}

      {/* Mens Top Products */}
      <section className="sale_items py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="d-flex justify-content-between">
                <h2 className='fs-4 fw_600'>Mens Top Products</h2>
                <div className="right d-flex align-items-center">
                  {/* <a href='#' title='Grid View' className="grid me-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"><path fill="currentColor" d="M14 10v4h-4v-4zm2 0h5v4h-5zm-2 11h-4v-5h4zm2 0v-5h5v4a1 1 0 0 1-1 1zM14 3v5h-4V3zm2 0h4a1 1 0 0 1 1 1v4h-5zm-8 7v4H3v-4zm0 11H4a1 1 0 0 1-1-1v-4h5zM8 3v5H3V4a1 1 0 0 1 1-1z" /></svg>
                  </a>
                  <a href='#' title='List View' className="list me-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"><path fill="currentColor" d="M3 13h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7zm-4 6h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7z" /></svg>
                  </a> */}

                  <a href="#" title='View All' className='fs_13'>View all <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48"><path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M19 12L31 24L19 36" /></svg></a>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <Product images={[
                "../mens/t-shirt.jpeg",
                "../mens/t-shirt1.jpeg",
                "../mens/t-shirt2.jpeg",
                "../mens/t-shirt3.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../mens/jeans.jpeg",
                "../mens/jeans1.jpeg",
                "../mens/jeans2.jpeg",
                "../mens/jeans3.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../mens/shoes.jpeg",
                "../mens/shoes1.jpeg",
                "../mens/shoes2.jpeg",
                "../mens/shoes3.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../mens/jacket.jpeg",
                "../mens/jacket1.jpeg",
                "../mens/jacket2.jpeg",
                "../mens/jacket3.jpeg"
              ]} />
            </div>
          </div>
        </div>
      </section>
      {/* Mens Top Products */}


      {/* Electronics */}
      <section className="sale_items py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="d-flex justify-content-between">
                <h2 className='fs-4 fw_600'>Electronics</h2>
                <div className="right d-flex align-items-center">
                  {/* <a href='#' title='Grid View' className="grid me-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"><path fill="currentColor" d="M14 10v4h-4v-4zm2 0h5v4h-5zm-2 11h-4v-5h4zm2 0v-5h5v4a1 1 0 0 1-1 1zM14 3v5h-4V3zm2 0h4a1 1 0 0 1 1 1v4h-5zm-8 7v4H3v-4zm0 11H4a1 1 0 0 1-1-1v-4h5zM8 3v5H3V4a1 1 0 0 1 1-1z" /></svg>
                  </a>
                  <a href='#' title='List View' className="list me-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"><path fill="currentColor" d="M3 13h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7zm-4 6h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7z" /></svg>
                  </a> */}

                  <a href="#" title='View All' className='fs_13'>View all <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48"><path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M19 12L31 24L19 36" /></svg></a>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <Product images={[
                "../electronics/mobile/redmi-c67e.jpeg",
                "../electronics/mobile/redmi-c67d.jpeg",
                "../electronics/mobile/redmi-c67c.jpeg",
                "../electronics/mobile/redmi-c67b.jpeg",
                "../electronics/mobile/redmi-c67a.jpeg",
                "../electronics/mobile/redmi-c67.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../electronics/laptop/laptop.jpeg",
                "../electronics/laptop/laptop1.jpeg",
                "../electronics/laptop/laptop2.jpeg",
                "../electronics/laptop/laptop3.jpeg",
                "../electronics/laptop/laptop4.jpeg",
                "../electronics/laptop/laptop5.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../electronics/watch/fastrack.jpeg",
                "../electronics/watch/fastrack1.jpeg",
                "../electronics/watch/fastrack2.jpeg",
                "../electronics/watch/fastrack3.jpeg",
                "../electronics/watch/fastrack4.jpeg",
                "../electronics/watch/fastrack5.jpeg",
                "../electronics/watch/fastrack6.jpeg"
              ]} />
            </div>
            <div className="col-md-3">
              <Product images={[
                "../electronics/bluetooth/noise.jpeg",
                "../electronics/bluetooth/noise1.jpeg",
                "../electronics/bluetooth/noise2.jpeg",
                "../electronics/bluetooth/noise3.jpeg",
                "../electronics/bluetooth/noise4.jpeg",
                "../electronics/bluetooth/noise5.jpeg"
              ]} />
            </div>
          </div>
        </div>
      </section>
      {/* Electronics */}




      <Footer />
    </div>
  )
}
